export const LOCAL_STORAGE_KEY = "x-auth-state-v4";
